import { useContext } from "react";
import { TenantContext } from "./TenantContext";

export const useTenant = () => {
  const { tenant, isTenantLoading } = useContext(TenantContext);

  return {
    tenant,
    isTenantLoading,
  };
};
